import { Component, Input, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BlendEvent, EncFile, ErrCode, FileItem, PathListApiInput, User, WebpathActionType } from 'src/app/shared/models';
import { FileItemService } from '../file-item.service';
import { FileListService } from 'src/app/file-list/services/file-list.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IFile } from 'src/sync';
import { BuildTransferItemService } from 'src/app/transfer/services/build-transfer-item.service';
import { ApiService } from 'src/app/core/api.service';
import { AppBarActionsService } from 'src/app/shared/layout/root-layout/app-bar-actions.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import * as FileListActions from '../../actions/file-list.actions';
import { Actions, ofType } from '@ngrx/effects';
import { ListItem } from '@material-library';
import { ShareService } from 'src/app/shared/services/share.service';
import { FileViewService } from '../file-view.service';
import { ProcessIndicatorService } from 'src/app/shared/services/process-indicator.service';
import { Title } from '@angular/platform-browser';
import { canBrowserOpen, getFileExt } from '../../shared/func';
import { LinkFileListService } from 'src/app/link-consume/services/link-file-list.service';
import { BlendService } from 'src/app/shared/services/blend.service';
import { DirPickerService } from 'src/app/shared/services/dir-picker.service';
import { PreviewImageComponent } from '../preview-image/preview-image.component';


@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent implements OnInit, OnDestroy {
  @ViewChild('dialoglinkcontent') dialoglinkcontent: TemplateRef<any>;
  @ViewChild('previewImage') previewImage:PreviewImageComponent

  @Input() public type: string;
  @Input() public item: IFile;
  @Input() public locId: number;
  @Input() isViewInDialog:boolean = false;

  public imageList: IFile[] = [];
  public initialized = false;
  public upsell = false;
  public notice = 0;
  public errcode: ErrCode;
  public isPro = 0; // not used, but the template requires it to be set

  public notPreviewable = false;
  public url: string;
  public mimeType: string;
  public user: User;
  public infoListItems: ListItem[] = [];
  public isPanelVisible: boolean = false;
  public isSmallScreen: boolean = false;
  public showInfoDialog: boolean = false;
  public showRenameDialog = false;
  public showMoveDialog = false;
  public showCopyDialog = false;
  public showDeleteDialog = false;
  private isFavorited: boolean;
  public WebpathActionType = WebpathActionType;
  private isSmScreen: boolean;
  public imageListReady = false;
  private PAGE_TITLE = 'Sync.com';
  public spinner = false;
  private isUploadAllowed: number;
  private compat: number;
  private isFileEditAllowed: number;
  private isCwdShared: number;
  private destroySubscriptions$ = new Subject<void>();
  public isVault: boolean;
  private fileListCWD:FileItem
  private fileListParents:EncFile[]
  constructor(
    private fileItemService: FileItemService,
    private fileListService: FileListService,
    private router: Router,
    private route: ActivatedRoute,
    private buildTransferItemService: BuildTransferItemService,
    private apiService: ApiService,
    private actionsService: AppBarActionsService,
    private store: Store<fromRoot.State>,
    private snackbarService: SnackbarService,
    private viewContainerRef: ViewContainerRef,
    private actions$: Actions,
    private shareService: ShareService,
    public breakpointObserver: BreakpointObserver,
    private ngZone: NgZone,
    private fileViewService: FileViewService,
    private processIndicatorService: ProcessIndicatorService,
    private pageTitleService: Title,
    private linkPathListService: LinkFileListService,
    private blendService: BlendService,
    public dirPickerService: DirPickerService,
  ) { }

  async ngOnInit() {
    if (this.isViewInDialog) {
      this.getUser();
      this.initialize();
      return;
    }
    this.route.paramMap
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe(async paramsMap => {
      this.spinner = true;      
      if (paramsMap) {
        this.type = paramsMap.get('type');
        this.locId = +paramsMap.get('id') || 0;
      } 
        await this.initialize();
      this.spinner = false;
    });
    this.isVault = this.route.snapshot.queryParams['tab'] ==='vault';
    this.locId = +this.route.snapshot.params['id'];

    if (!this.type) {
      this.type = this.route.snapshot.params['type'];
    }

    this.actions$.pipe(
      ofType(FileListActions.FILE_LIST_RELOAD)
    )
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe(async () => {
      this.updateActions()
    });


    this.getUser();


    this.shareService.openPanel$
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe(() => {
      this.openSidePanel();
    });

    this.breakpointObserver
      .observe(['(max-width: 599px)'])
      .pipe(takeUntil(this.destroySubscriptions$))
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isSmallScreen = true;
          this.isPanelVisible = false;
          this.isSmScreen = true
        }else{
          this.isSmScreen = false
          this.showInfoDialog = false;
          requestAnimationFrame(() => {
            this.ngZone.run(() => {
              this.isSmallScreen = false;
            });
          })
        }
        this.updateActions();
      });
  
    await this.fileViewService.inited;
  }

  public getUser = () => {
    this.store
    .pipe(select(fromRoot.getAuthUser))
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe((data) => {
      this.user = data;
    });
  }

  private updateActions() {
    if (!this.item) return;
    const allActions =  [
      {
        name: !this.item.is_publink ? 'Share as link' : 'Manage link',
        icon: 'link',
        onClick: this.onLinkDialog,
      },

      'divider',

      {
        name: 'Open in browser',
        icon: 'open-in-new',
        onClick: () => {
          this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Open in browser', mimeType: this.item.mime_type });
          this.fileViewService.openFile(this.item);
        },
        shouldShow: () => this.fileViewService.isOpenable(this.item) && this.item.type == 'file'
      },

       'divider',
       
      {
        name: 'View in Offce',
        icon: 'preview',
        onClick: () => {
          this.fileViewService.openOfficeView(this.item);
        },
        shouldShow: () => this.fileViewService.showOfficeView(this.item) && this.isSmScreen,
      },
      
      {
        name: 'Download',
        icon: 'download',
        onClick: () => {
          this.fileViewService.downloadCompat(this.item);
        },
        shouldShow: () => this.fileViewService.showDownload(this.item),
      },

      'divider',

      {
        name: this.isFavorited ? 'Remove from starred' : 'Add to starred',
        icon: this.isFavorited ? 'star-filled' : 'star',
        onClick: (rowData, event: Event) => {
          event?.stopPropagation?.();
          this.fileViewService.updateStarred([this.item], !this.isFavorited);
        },
      },  
      
      'divider',

      {
        name: 'Edit in Office',
        icon: 'edit',
        onClick: (rowData) => {
          this.fileViewService.openOfficeEdit(this.item, this.route)
        },
        shouldShow: () => this.fileViewService.showOfficeEdit(this.item) && !this.isSmScreen 
      },

       'divider',
       
      {
        name: 'Rename',
        icon: 'rename',
        onClick: (rowData: any, event: Event) => {
          this.showRenameDialog = true;
        }
      },

      {
        name: 'Copy',
        icon: 'copy-file',
        onClick: (rowData: any, event: Event) => {
          this.showCopyDialog = true;
        }
      },

      {
        name: 'Duplicate',
        icon: 'duplicate',
        onClick: async (rowData: any, event: Event) => {
          this.processIndicatorService.showProcessIndicator({ text: 'Duplicating...' });
          const r = await this.fileViewService.duplicateFile([this.item]);
          if (r?.length) {

            this.blendService.track(BlendEvent.DUPLICATE_ITEM, {
              type: this.item.type,
              size: this.item.filesize,
              mime_type: this.item.mime_type,
            });

            this.fileListService.reload();     
            this.snackbarService.showMessage("success", `Duplicated “${this.item.name}”`, {
              shouldDismissAfterAction: false,
              trailAdornmentConfig: {
                enabled: true,
                type: 'button',
                size: 'large',
                buttonConfig: {
                  type: 'flat',
                  label: 'View file',
                  color: 'neutral',
                  size: 'small',
                  onClick: () => {
                    this.router.navigate([this.fileItemService.generatePreviewLink(r[0].new_sync_id, this.type)])
                  },
                },
              }
            }); 
          }
          else {
            this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
          }
          this.processIndicatorService.hideProcessIndicator();
        }
      },

      {
        name: 'Move',
        icon: 'move-file-folder',
        onClick: (rowData: any, event: Event) => {
          this.showMoveDialog = true;
        }
      },
      
      {
        name: 'Delete',
        icon: 'delete',
        onClick: (rowData: any, event: Event) => {
          this.showDeleteDialog = true;
        },
        divider: true,
      },
      
      {
        name: 'File info',
        icon: 'info',
        onClick: (rowData: any, event: Event) => {
          this.openSidePanel();
        }
      },

      {
        name: 'Version history',
        icon: 'clock',
        onClick: (rowData: any, event: Event) => {
          this.router.navigate([`files/file-history/${this.item.sync_id}`]);
        }
      },
    ]

    const actions = [];
    for (const action of allActions) {
      if (action == 'divider') {
        if (actions.length) {
          actions[actions.length - 1].divider = true;
          actions[actions.length - 1].type ='primary'
        }
      }
      else {
        actions.push(action);
      }
    }

    this.actionsService.updateActions({
      limit: 5,
      showActionsInBottomSheet: true,
      rowData: {},
      actions,
    });
  }

  onLinkDialog = () =>{
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.dialoglinkcontent);
  }

  openSidePanel = () => {
    if(this.isSmallScreen){
      this.isPanelVisible = false;
      this.showInfoDialog = true;
    }else{
      this.isPanelVisible = true;
      this.showInfoDialog = false;
    }
  }

  closeSidePanel = () => {
    this.isPanelVisible = false;
  }

  closeInfoDialog = () => {
    this.showInfoDialog = false;
  }

  public onStateChange(event: any) {
    this.type = event.type;
    this.upsell = event.upsell;
    this.notPreviewable = true;
    this.initialize();
  }

  private updateItem = async () => {
    const pathget = this.isViewInDialog ? this.item : await this.apiService.execute('pathget', {
      sync_id: this.locId,
    });
    this.item = await this.fileItemService.format(pathget);
  }

  private async initialize() {
    this.initialized = false;
    let dispatched = false;
    try {
      await this.updateItem();

      this.pageTitleService.setTitle(
        `${this.item.name} | ${this.PAGE_TITLE}`
      );
      
      this.initializeFileInfo(this.item);
      const previewType = this.fileItemService.previewFileType(this.item);
      if (!this.notPreviewable && this.type !== previewType && this.type != 'officefse' && this.type != 'officefsv') {
        this.type = previewType;
        this.changeUrlType(this.type);
      }
      const streamItem =
        await this.buildTransferItemService.getStreamingDetails(this.item);
        if (streamItem.url && streamItem.mimeType) {
          if (this.user?.is_pro) {
            if (streamItem.mimeType.startsWith('video/')) {
              this.type = 'video';
            } else if (streamItem.mimeType.startsWith('audio/')) {
              this.type = 'audio';
            } else {
              this.type = 'unknown';
            }
          } else {
            this.type = 'default';
          }
          this.url = streamItem.url;
          this.mimeType = streamItem.mimeType;
        }

      if (
        (this.type != 'office' && this.type != 'officefse' && this.type != 'officefsv') &&
        !this.fileItemService.isPreviewable(this.item)
      ) {
        this.type = 'default';

        const ext = this.fileItemService.getFileExt(this.item.name);
        const isLargeExcel =
          (ext === 'xls' || ext === 'xlsx') && this.item.size > this.fileItemService.MAX_PREVIEW_SIZE_XLS;

        this.notice = 0;
        this.upsell = false;

        if (isLargeExcel && !this.user?.is_pro) {
          this.notice = 1;
          this.upsell = true;
        } else if (this.isOpenable() && this.user?.is_pro) {
          this.notice = 1;
        }
      }

      this.fileListService
        .getListSubscription()
        .pipe(takeUntil(this.destroySubscriptions$))
        .subscribe((data) => {
          if (data && data.pathlist && data.pathlist.length) {
            this.fileListParents = data.parents
            this.fileListCWD = data.cwd;
            const fullList = data.pathlist;
            if (data.sorted) {
              // Filter out image files
              this.imageList = fullList.filter((val) => {
                return this.fileItemService.isImage(val);
              });
            }
            this.initialized = true;
            this.imageListReady = true;
            const item = fullList.find(i => i.sync_id === this.locId);
            this.isFavorited = item?.is_favorite;
            this.updateActions();
          } else if (!dispatched) {
            const input = new PathListApiInput();
            input.sync_id = this.item.pid;
            input.hist_id = 0;
            input.showdeleted = 0;
            this.fileListService.dispatch(input);
            dispatched = true;
          }
        });

      //white label attributes
      this.linkPathListService
          .getSubscription()
          .pipe(takeUntil(this.destroySubscriptions$))
          .subscribe((data) => {
              if (data.loaded && data.sorted) {
                this.isUploadAllowed = data.upload;
                this.compat = data.compat;
                this.isFileEditAllowed = data.file_edit;
                this.isCwdShared = data.cwd.is_shared;
              }
          });
    } catch (ex) {
      this.errcode = ErrCode.fromException(ex);
      this.type = 'error';
      this.initialized = true;
    }
  }

  private initializeFileInfo(fileItem: IFile) {
    this.infoListItems = [
      {
        primaryText: fileItem.name,
        overlineText: 'FILE NAME'
      },
      {
        primaryText: fileItem.kind.toUpperCase(),
        overlineText: 'FILE TYPE'
      },
      {
        primaryText: fileItem.filesize,
        overlineText: 'FILE SIZE'
      },
      {
        primaryText: this.shareService.formatTimestamp(fileItem.usertime),
        overlineText: 'LAST MODIFIED'
      },
      {
        primaryText: fileItem.id,
        overlineText: 'ID'
      }
    ];
  }

  getCurrentFile(file: IFile) {
    this.fileItemService.fileItemSubject.next(file);
    this.initializeFileInfo(file);
    if (!this.isViewInDialog) {
      const previewLink = this.fileItemService.generatePreviewLink(file.sync_id, this.type);
      this.router.navigate([previewLink], { replaceUrl: true });
    }
  }

  changeUrlType(newType: string): void {
    const fullUrl = this.router.url;

    // Replace the last segment (e.g., /default) with the new type (e.g., /doc)
    // Regex: /\/[^\/]*$/ matches the last segment after the final '/' in the URL
    // Example: /file/15000002/view/default -> /file/15000002/view/doc
    const newUrl = fullUrl.replace(/\/[^\/]*$/, `/${newType}`);

    this.router.navigateByUrl(newUrl);
  }

  ngOnDestroy() {
    this.actionsService.updateActions(null);
    // Unsubscribe from subscriptions to avoid memory leaks
    this.destroySubscriptions$.next();
    this.destroySubscriptions$.complete();
  }

  onRenameSuccess = response => {
    const previewLink = this.fileItemService.generatePreviewLink(response.new_sync_id, this.type);

    this.blendService.track(BlendEvent.RENAME_ITEM);

    this.router.navigate([previewLink], { replaceUrl: true });
    this.fileListService.reload();
  }

  onDeleteSuccess = () => {
    let hasNextImage = false;
    let hasPreviousImage = false;
    const index = this.imageList?.findIndex(i => i.sync_id === this.locId);
    if(this.imageList && this.imageList.length){
      if(index>-1 && index < (this.imageList.length-1)){
        hasNextImage = true;
      }else if(index>-1  && index == (this.imageList.length - 1)){
        hasPreviousImage = true;
      }
    }
    let imgItem:IFile
    if(hasNextImage && this.previewImage){
      imgItem = this.imageList[index+1];
      if(imgItem){
      this.previewImage.navigateNext();
      this.previewImage.getNextPrevItems(imgItem);
      this.fileListService.reload();     
      return;
    }
    }
    if(this.previewImage && hasPreviousImage && (index-1> -1)){
      imgItem = this.imageList[index-1]
      if(imgItem){
        this.previewImage.navigatePrev();
        this.fileListService.reload();     
        return;
      }
    }

    let path= 'files';
    if(+this.fileListParents[0]['loc_id'] === this.dirPickerService.getRootVaultId){
      path = 'vault'
      if(this.dirPickerService.getRootVaultId != this.fileListCWD.sync_id){
        path +='/'+this.fileListCWD.sync_id
      }
    }else if(+this.fileListParents[0]['loc_id'] ===this.dirPickerService.getRootSyncId){
      path = 'files'
      if(this.dirPickerService.getRootSyncId != this.fileListCWD.sync_id){
        path +='/'+this.fileListCWD.sync_id
      }
    }
    this.router.navigate(['/'+path]);
  }

  onLinkMutate = async () => {
    await this.updateItem();
    this.fileItemService.fetchFileItem(this.locId);
    this.updateActions();
  }

  private isOpenable() {
    if (this.item.context == 'link' && (this.item.previewonly == 8 || !this.compat)) {
      return false;
    }
    if (
      this.item.context == 'link' &&
      getFileExt(this.item.name) == 'pdf' &&
      !this.item.link_is_business
    ) {
      return false;
    }
    if (this.item.context == 'link' && this.fileItemService.isMSOffice(this.item, 'edit')) {
      return (
        this.fileItemService.isOfficeLinkEdit(this.item, this.isUploadAllowed, this.isFileEditAllowed, this.isCwdShared)
      );
    }
    const isVideo = this.fileItemService.isVideo(this.item);
    const isAudio = this.fileItemService.isAudio(this.item);
  
    if (this.fileItemService.isLikelyMediaFile(this.item.name) && !(isVideo || isAudio)) {
      return false;
    }
    if (!canBrowserOpen(this.item.name)) {
      return false;
    }
    // return this.item.compat
    //     ? canLinkBrowserOpen(this.item.name)
    //     : canBrowserOpen(this.item.name);
    return true;
  }
}
